import * as React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { default as RubroEdit } from "../../components/Rubro/rubroNuevo";
import {
  sagaGetSubRubroId,
  sagaSaveSubRubro,
  sagaSaveImagenRubro,
} from "../../reducers/rubrosReducer/actions";
import { subrubrosEditSelector } from "../../selectors/rubrosSelector";
import * as Notification from "../../components/Common/notification";
import { compress, calculateNewSize } from "../../components/Common/imageCompressor";

class SubRubroEditContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rubro: {
        nombre: "",
      },
      currentFiles: [],
      openModalImagen: false,
      imagenOriginal: undefined,
    };

    // busco los datos iniciales
    let id = props.match.params.idSubrubro;
    if (id === "0") id = null;
    this.props.sagaGetSubRubroId(id);
  }

  UNSAFE_UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      rubro: {
        ...nextProps.rubro.rubro,
        idTemporal: Math.floor(Math.random() * 10000),
      },
      imagenOriginal: nextProps.rubro.rubro.imagenOriginal,
    });
    this.render();
  }

  onRecorteImagenCompressed = (currentFile) => {
    // guardo el recorte
    let payload = {
      subrubro: true,
      currentFile: currentFile,
      idTemporal: this.state.rubro.idTemporal,
      original: false,
    };
    this.props.sagaSaveImagenRubro(payload);

    // genero el image source
    let recorte = URL.createObjectURL(currentFile);

    // actualizo el catálogo
    this.setState({
      rubro: { ...this.state.rubro, imagen: recorte },
      openModalImagen: false,
    });
  };

  handleOnSaveImagenCortada = (recorte, blobData, imageData) => {
    // obtengo el nombre de archivo. Si se trata de edicion voy al state catalogo.

    let fileName = "avatar";

    // comprimo la imagen
    let newSize = calculateNewSize(imageData.width, imageData.height, 400, 600);
    compress(blobData, fileName, newSize.width, newSize.height, this.onRecorteImagenCompressed);
  };

  handleOnDropFile = (acceptedFiles, rejectedFiles) => {
    if (rejectedFiles.length !== 0) {
      if (rejectedFiles.length === 1) Notification.showError("Formato de Imagen no aceptado.");
      if (rejectedFiles.length > 1)
        Notification.showError("Se permite solo una imagen para el rubro.");
    } else {
      if (acceptedFiles.length !== 0) {
        let currentFile = acceptedFiles[0];

        //creo una imagen para conocer las dimensiones del archivo
        let _self = this;
        let img = new Image();
        img.onload = function () {
          let newSize = calculateNewSize(this.width, this.height, 750 * 2, 1125 * 2); //*2 para aumentar la calidad

          //comprimo la imagen a una dimension manejable
          compress(
            currentFile,
            currentFile.name,
            newSize.width,
            newSize.height,
            (imageCompressed) => {
              let file = URL.createObjectURL(imageCompressed);
              let payload = {
                subrubro: true,
                currentFile: currentFile,
                idTemporal: _self.state.rubro.idTemporal,
                original: true,
              };
              _self.props.sagaSaveImagenRubro(payload);
              //Agrego un prefijo para poder obtenerla luego. En la imagenHelper le agrego el prefijo antes de guardar, ya que el campo name del currentFile es read only
              let newImgSrc = {
                Path: currentFile.name,
                selected: false,
                idArticuloImagenes: 0,
                Orden: 1,
                Miniatura: true,
                PathImagen: file,
              };
              let rubro = { ..._self.state.rubro };
              rubro.imgSrc = newImgSrc;
              _self.setState({
                rubro: { ...rubro, imagen: file },
                imagenOriginal: newImgSrc.PathImagen,
                currentFile: imageCompressed,
                //openModalImagen:true
              });
            }
          );
        };
        img.src = URL.createObjectURL(currentFile);
      }
    }
  };

  handleOnCloseCropperModal = () => {
    this.setState({ openModalImagen: false });
  };

  handleOnOpenCropperModal = () => {
    this.setState({ openModalImagen: true });
  };

  validar = () => {
    let valido = true;
    let error = {};
    if (
      this.state.rubro.nombre === null ||
      this.state.rubro.nombre === undefined ||
      this.state.rubro.nombre === ""
    ) {
      error.nombre = "Debe definir un nombre";
      valido = false;
    }

    this.setState({ error: error });

    return valido;
  };

  render() {
    return (
      <RubroEdit
        entidad="Sububro"
        handleOnChange={(x) => {
          this.setState({
            rubro: {
              ...this.state.rubro,
              ...pathValue(x.target.name.split(".").reverse(), x.target.value),
            },
          });
        }}
        handleOnCancel={() => {
          this.props.history.goBack();
        }}
        handleOnSave={() => {
          /** save subrubro */
          if (this.validar())
            this.props.sagaSaveSubRubro({
              idSubrubro: this.state.rubro.idSubrubro,
              idTemporal: this.state.rubro.idTemporal,
              nombre: this.state.rubro.nombre,
              idRubro:
                this.state.rubro.idRubro === 0
                  ? this.props.match.params.idRubro
                  : this.state.rubro.idRubro,
            });
        }}
        handleOnDropFile={this.handleOnDropFile}
        handleOnCloseCropperModal={this.handleOnCloseCropperModal}
        handleOnOpenCropperModal={this.handleOnOpenCropperModal}
        handleOnSaveImagenCortada={this.handleOnSaveImagenCortada}
        {...this.state}
      />
    );
  }
}

function pathValue(path, value) {
  if (path.length === 1) {
    return { [path[0]]: value };
  } else {
    let p = path.pop();
    return { [p]: pathValue(path, value) };
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      sagaGetSubRubroId,
      sagaSaveSubRubro,
      sagaSaveImagenRubro,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    rubro: subrubrosEditSelector(state),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SubRubroEditContainer);
